import { Link } from "react-router-dom";

const SUPPORT_EMAIL = "customersupport@driveclearapp.com";

export default function Footer() {
  return (
    <footer data-testid="global-footer" className="bg-stone-950 text-stone-400 py-16 text-xs">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 pb-12 border-b border-stone-800">
          <div>
            <div className="mb-4">
              <span className="inline-flex bg-white rounded-xl px-3 py-2">
                <img src="/logo.png" alt="DriveClear" className="h-7 w-auto" />
              </span>
            </div>
            <p className="text-stone-400 leading-relaxed text-xs">
              Know if the car fits before you buy it. Financial clarity for car buyers — educational estimates, not a credit offer or lending decision.
            </p>
          </div>

          <nav aria-label="Calculators">
            <div className="text-xs font-bold uppercase tracking-wider text-stone-200 mb-4">Calculators</div>
            <ul className="space-y-2">
              <li><Link to="/car-payment-calculator" data-testid="footer-car-payment-calculator" className="hover:text-white transition-colors">Car Payment Calculator</Link></li>
              <li><Link to="/car-loan-calculator" data-testid="footer-car-loan-calculator" className="hover:text-white transition-colors">Car Loan Calculator</Link></li>
              <li><Link to="/car-affordability-calculator" data-testid="footer-car-affordability-calculator" className="hover:text-white transition-colors">Car Affordability Calculator</Link></li>
              <li><Link to="/dti-calculator" data-testid="footer-dti-calculator" className="hover:text-white transition-colors">DTI Calculator</Link></li>
              <li><Link to="/car-cost-of-ownership" data-testid="footer-car-cost-of-ownership" className="hover:text-white transition-colors">Cost of Ownership</Link></li>
            </ul>
          </nav>

          <nav aria-label="Company and support">
            <div className="text-xs font-bold uppercase tracking-wider text-stone-200 mb-4">DriveClear</div>
            <ul className="space-y-2">
              <li><a href="/#how-it-works" data-testid="footer-how-it-works" className="hover:text-white transition-colors">How It Works</a></li>
              <li><Link to="/learn" data-testid="footer-learn" className="hover:text-white transition-colors">Learn</Link></li>
              <li><Link to="/about" data-testid="footer-about" className="hover:text-white transition-colors">About</Link></li>
              <li><Link to="/support" data-testid="footer-contact" className="hover:text-white transition-colors">Contact Support</Link></li>
              <li><a href={`mailto:${SUPPORT_EMAIL}`} data-testid="footer-support-email" className="hover:text-white transition-colors">{SUPPORT_EMAIL}</a></li>
            </ul>
          </nav>

          <div>
            <div className="text-xs font-bold uppercase tracking-wider text-stone-200 mb-4">Legal Disclaimer</div>
            <p className="text-[11px] text-stone-500 leading-relaxed">
              DriveClear provides informational estimates only. DriveClear is not a bank, lender, or credit repair organization. Nothing on this site is a credit offer or lending decision.
            </p>
          </div>
        </div>

        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between text-stone-500 text-[11px] gap-4">
          <div>DriveClear Technologies. All rights reserved.</div>
          <div className="flex items-center gap-6">
            <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-stone-300 transition-colors">Privacy Policy</Link>
            <Link to="/terms" data-testid="footer-terms-link" className="hover:text-stone-300 transition-colors">Terms of Service</Link>
            <Link to="/delete-account" data-testid="footer-delete-account-link" className="hover:text-stone-300 transition-colors">Delete account</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
